export default __webpack_public_path__ + "static/media/email_icon.68f02a7d.svg";